/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Using double rounding to round a number to 2 decimal places, 
  and we use the .toPrecision() method to eliminate floating-point rounding errors 
  introduced during intermediate calculations using simple rounding */
function round(num) {
  var m = Number((Math.abs(num) * 100).toPrecision(15));
  return Math.round(m) / 100 * Math.sign(num);
}

function addProductsNeededToCart(id, quantity, productType, width, height) {
  let items = [];
  if (productType && productType === "tapis") {
    items = [
      {
        'id': id,
        'quantity': quantity,
        'properties' : {
          'longueur': `\u00A0${height}\u00A0cm`,
          'largeur': `\u00A0${width}\u00A0cm`,
        }
      }
    ];
  } else if (productType && productType === "décor") {
    items = [
      {
        'id': id,
        'quantity': quantity,
        'properties' : {
          'hauteur': `\u00A0${height}\u00A0cm`,
          'largeur': `\u00A0${width}\u00A0cm`,
        }
      }
    ];
  } else if (productType && productType === "basic") {
    items = [
      {
        'id': id,
        'quantity': quantity,
      }
    ];
  }

  fetch('/cart/add.js', {
    body: JSON.stringify({ 'items': items }),
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    }
  }).then(response => {

    document.dispatchEvent(new CustomEvent('theme:loading:end'));

    if (response.ok) {
      // We simulate the click on the drawer to open it and then we refresh the basket (wonky but it's a first functional method...)
      const cartDrawerIcon = document.querySelector(".Header__Icon[data-drawer-id='sidebar-cart']")

      cartDrawerIcon.click();

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
      }));
      
      // console.log(items)
    } else {
      response.json().then(function (content) {

        const errorMessageElement = document.createElement('span');
        errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
        errorMessageElement.innerHTML = content['description'];
        document.querySelector( '.add-to-cart' ).removeAttribute( 'disabled' );
        document.querySelector( '.add-to-cart' ).insertAdjacentElement( 'afterend', errorMessageElement );

        setTimeout(function () {
          errorMessageElement.remove();
        }, 2500);
      });
    }
  });
}